import React from 'react'
import styled from 'styled-components'

export default ({type, data}) => {
  return (
    <InfoWithDate>
      <TopInfo>
        <TopInfoSpan type={type}>
          {data.date}
        </TopInfoSpan>
        <TopInfoSpan type={type}>
          :: {data.title} ({data.country})
        </TopInfoSpan>
      </TopInfo>
      {data.infos.map(info => {
        return (
          <Description key={info} type={type}>
            <Dash>/</Dash>{info}
          </Description>
        )
      })}
    </InfoWithDate>
  )
}
const InfoWithDate = styled.div`
  width: 100%;
  padding: 0.5rem 1rem;
  @media(min-width: 900px) {
    font-size: 1.2rem;
    margin-left: 3rem;
    margin-bottom: 0.5rem;
  }
`
const TopInfo = styled.h3`
  display: flex;
  flex-direction: column;
  @media(min-width: 900px) {
    flex-direction: row;
  }
`
const TopInfoSpan = styled.span`
  font-family: DINMed;
  font-weight: 100;
  color: ${props => props.type === 'career' ? props.theme.green : props.theme.beige};
  @media(min-width: 900px) {
    margin-right: 1rem;
    margin-bottom: 0.3rem;
  }
`
const Dash = styled.span`
  font-size: 0.5rem;
  margin-right: 0.5rem;
  padding-left: 0.8rem;
  @media(min-width: 900px) {
    font-zie: 1.5rem;
    padding-left: 1.3rem;
  }
`
const Description = styled.p`
  color: ${props => props.type === 'career' ? props.theme.green : props.theme.beige};
  font-family: DINReg;
  margin-top: 0.5rem;
  font-weight: 100;
  font-size: 1rem;
  @media(min-width: 900px) {
    font-size: 1.2rem;
  }
`